import styled from '@emotion/styled';
import { InputNumber, InputNumberProps, Select, SelectProps } from 'antd';
import FormField from 'components/FormField';
import useSmartField from 'hooks/useSmartField';
import { DisabledProps, FV, IsPolicyProps, PlatformProps } from './share';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { T, useTranslate } from '@tolgee/react';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';

export const Inline = styled.div`
  > div {
    margin: 0 8px;
  }
  .ant-select {
    width: auto;
  }
`;

function X(props: InputNumberProps<number>) {
  const { children, ...others } = props;

  return <InputNumber {...others} />;
}

function TimeUnit(props: SelectProps<FV['timeoutReplyTaskConfig']['executeTimeUnit']>) {
  const { children, ...others } = props;

  return <Select {...others} />;
}

function TimeoutReplyField(props: DisabledProps & IsPolicyProps & PlatformProps) {
  const { disabled = false, isPolicy = false, platform } = props;

  const { t } = useTranslate();

  const coolDownHour = (
    <FormField<FV['timeoutReplyTaskConfig']['coolDownHour']>
      name={
        isPolicy
          ? 'scenarioConfig.timeoutReplyTaskConfig.coolDownHour'
          : 'timeoutReplyTaskConfig.coolDownHour'
      }
      label={t('aide.冷却时间')}
      validate={(value) => (value ? undefined : t('department.请输入x', { x: t('aide.冷却时间') }))}
    >
      {({ field }) => {
        return (
          <Inline>
            <T
              keyName="aide.同一买家在x小时内只会触发一次超时自动回复"
              params={{
                x: <X disabled={disabled} min={1} max={48} precision={0} {...field} />,
              }}
            />
          </Inline>
        );
      }}
    </FormField>
  );

  const { qaEnable: isQa } = useOrgConfigStateValue();

  const {
    field: { value: timeUnit, onChange: onTimeUnitChange },
  } = useSmartField<FV['timeoutReplyTaskConfig']['executeTimeUnit']>(
    isPolicy
      ? 'scenarioConfig.timeoutReplyTaskConfig.executeTimeUnit'
      : 'timeoutReplyTaskConfig.executeTimeUnit',
  );

  const getRange = (unit: FV['timeoutReplyTaskConfig']['executeTimeUnit']) => {
    if (unit === '2') {
      return [1, isTiKTokUpperCase(platform) ? 24 : 12];
    }

    if (isQa) {
      return [5, 360];
    }

    return [1, 360];
  };

  const range = getRange(timeUnit);

  const execute = (
    <FormField<FV['timeoutReplyTaskConfig']['executeTime']>
      name={
        isPolicy
          ? 'scenarioConfig.timeoutReplyTaskConfig.executeTime'
          : 'timeoutReplyTaskConfig.executeTime'
      }
      label={t('marketing.执行时间')}
      validate={(time) => (time ? undefined : t('marketing.请输入执行时间'))}
    >
      {({ field: { value, onChange, onBlur } }) => {
        return (
          <Inline>
            <T
              keyName="aide.买家咨询后x timeUnit内客服未进行回复，则自动回复指定信息"
              params={{
                x: (
                  <X
                    disabled={disabled}
                    min={range[0]}
                    max={range[1]}
                    precision={0}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                  />
                ),
                timeUnit: (
                  <TimeUnit
                    disabled={disabled}
                    value={timeUnit}
                    onChange={(unit) => {
                      onTimeUnitChange(unit);

                      const limit = getRange(unit);

                      if (value < limit[0] || value > limit[1]) {
                        onChange(limit[0]);
                      }
                    }}
                    options={[
                      { value: '2', label: t('marketing.小时') },
                      { value: '1', label: t('marketing.分钟') },
                    ]}
                  />
                ),
              }}
            />
          </Inline>
        );
      }}
    </FormField>
  );

  return (
    <>
      {coolDownHour}
      {execute}
    </>
  );
}

export default TimeoutReplyField;
